import { render, staticRenderFns } from "./SeparateFileTable.vue?vue&type=template&id=1a712565&scoped=true&lang=pug"
import script from "./SeparateFileTable.vue?vue&type=script&lang=ts"
export * from "./SeparateFileTable.vue?vue&type=script&lang=ts"
import style0 from "./SeparateFileTable.vue?vue&type=style&index=0&id=1a712565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a712565",
  null
  
)

export default component.exports